import { render, staticRenderFns } from "./user-approver-blocked-modal.vue?vue&type=template&id=33927fa0&scoped=true&"
import script from "./user-approver-blocked-modal.vue?vue&type=script&lang=js&"
export * from "./user-approver-blocked-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-approver-blocked-modal.vue?vue&type=style&index=0&id=33927fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33927fa0",
  null
  
)

export default component.exports